module.exports = __webpack_public_path__ + "img/fraud.bf4ff92b.png";